export const getBannersSlides = "https://ansdpad-backend-ui.onrender.com/api/banners?populate=*";
export const getDPADNewsItems = "https://ansdpad-backend-ui.onrender.com/api/dpad-news-items?populate=*";